"use client";

import { mainFeatures } from "@/data/main-data";
import { useLocale } from "next-intl";
import Image from "next/image";
import { motion } from "framer-motion";

export default function Features() {
  const locale = useLocale();

  return (
    <section>
      <div className="flex flex-col items-center lg:items-start lg:flex-row justify-center gap-5 mt-20 flex-wrap">
        {mainFeatures.map((feature) => (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: feature.id * 0.2 }}
            viewport={{ once: true }}
            key={feature.id}
            className="flex flex-col items-center max-w-100 mb-8 w-full"
          >
            <Image
              src={feature.icon}
              alt={locale === "en" ? feature.name_en : feature.name_ar}
              width={50}
              height={50}
            />
            <h4 className="mt-4 font-semibold text-center text-base text-main">
              {locale === "ar" ? feature.name_ar : feature.name_en}
            </h4>
            <p className="text-center text-sm text-secondary mt-3 leading-6">
              {locale === "ar"
                ? feature.description_ar
                : feature.description_en}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
